import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Layout/Navbar';
import styles from './LandingPageV2.module.css';

const AlexBookCallPage = () => {
    useEffect(() => {
        // We need to load the external script for the form embed
        const script = document.createElement('script');
        script.src = "https://api.roofingassist.ai/js/form_embed.js";
        script.async = true;
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        }
    }, []);

    return (
        <div className={`${styles['roofing-assist-landing-new']}`}>
            <Navbar theme="light" />
            <div className={`${styles.container}`}>

                <div style={{ padding: '80px 20px', display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
                    <div style={{ width: '100%', maxWidth: '1000px', margin: '0 auto', textAlign: 'center' }}>
                        <div className={`${styles.eyebrow}`} style={{ justifyContent: 'center' }}>Ready when you are</div>
                        <h1 className={`${styles.headline}`} style={{ marginBottom: '20px' }}>
                            See the operating system live.
                        </h1>
                        <p className={`${styles.subtext}`} style={{ margin: '0 auto 40px auto' }}>
                            No pitch deck. No pressure. We walk you through your operation, show you what changes, and let you decide if it's worth switching.
                        </p>
                        
                        <div style={{ background: '#fff', borderRadius: '12px', padding: '24px', boxShadow: '0 12px 40px rgba(0,0,0,0.08)', width: '100%' }}>
                            <iframe 
                                src="https://api.roofingassist.ai/widget/booking/QV9uGb2shQV0GqaHjvwf" 
                                style={{ width: '100%', border: 'none', overflow: 'hidden', minHeight: '650px' }} 
                                scrolling="no" 
                                id="QV9uGb2shQV0GqaHjvwf_1778700341357"
                                title="Book a Call with Alex"
                            ></iframe>
                        </div>
                    </div>
                </div>
            </div>

            <footer className={`${styles['site-footer']}`}>
                <div className={`${styles['sf-container']}`}>
                    <div className={`${styles['sf-eyebrow']}`}>ANY QUESTIONS?</div>
                    <h2 className={`${styles['sf-headline']}`}>We're here to help.</h2>
                    <p className={`${styles['sf-desc']}`}>Reach out to our team if you need anything before your call.</p>
                </div>
            </footer>
        </div>
    );
};

export default AlexBookCallPage;
